import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Transfer, CreateTransferDto, CashHandoffDto } from '../models/transfer.model';
import { apiBase } from './api-config';

@Injectable({ providedIn: 'root' })
export class TransferService {
  private http = inject(HttpClient);
  private base = `${apiBase}/transfers`;

  getAll(personnelId?: number): Observable<Transfer[]> {
    const params = personnelId ? new HttpParams().set('personnelId', personnelId) : undefined;
    return this.http.get<Transfer[]>(this.base, { params });
  }

  getById(id: number): Observable<Transfer> {
    return this.http.get<Transfer>(`${this.base}/${id}`);
  }

  create(dto: CreateTransferDto): Observable<Transfer> {
    return this.http.post<Transfer>(this.base, dto);
  }

  cashHandoff(dto: CashHandoffDto): Observable<Transfer> {
    return this.http.post<Transfer>(`${this.base}/cash-handoff`, dto);
  }
}
